import { ApprovalStepStatus } from 'ui-product-approvals-common/types/ApprovalData';
import { ApprovalRules } from 'ui-product-approvals-common/types/ApprovalRules';
import { serializeActor } from 'ui-product-approvals-common/utils/actorKey';
import { ACTOR } from '../constants/actors';
export const groupRowsByOrder = approvalSteps => {
  const byOrder = new Map();
  const withoutOrder = [];
  approvalSteps.forEach(step => {
    var _byOrder$get;
    if (step.order === undefined) {
      withoutOrder.push(step.approver);
      return;
    }
    const group = (_byOrder$get = byOrder.get(step.order)) !== null && _byOrder$get !== void 0 ? _byOrder$get : [];
    group.push(step.approver);
    byOrder.set(step.order, group);
  });
  const orderedGroups = [...byOrder.entries()].sort(([orderA], [orderB]) => orderA - orderB).map(([, group]) => group);
  return withoutOrder.length > 0 ? [withoutOrder, ...orderedGroups] : orderedGroups;
};
export const groupStepsByOrder = approvalSteps => {
  const byOrder = new Map();
  approvalSteps.forEach(step => {
    var _step$order, _byOrder$get2;
    const order = (_step$order = step.order) !== null && _step$order !== void 0 ? _step$order : 0;
    const group = (_byOrder$get2 = byOrder.get(order)) !== null && _byOrder$get2 !== void 0 ? _byOrder$get2 : [];
    group.push(step);
    byOrder.set(order, group);
  });
  return [...byOrder.entries()].sort(([orderA], [orderB]) => orderA - orderB).map(([, group]) => group);
};
export const isGroupComplete = (group, approvalRules) => {
  const isApproved = step => step.approvalStepStatus === ApprovalStepStatus.APPROVED;
  return approvalRules === ApprovalRules.ANY_CAN_APPROVE ? group.some(isApproved) : group.every(isApproved);
};
export const shouldWarnInvalidApprover = (step, validApproverActorKeys, isFetchApproversError, isLoadingApprovers) => step.approver.actor.actorType === ACTOR.USER && !isFetchApproversError && !isLoadingApprovers && step.approvalStepStatus === ApprovalStepStatus.APPROVAL_PENDING && !validApproverActorKeys.has(serializeActor(step.approver.actor));
export const toApprovalStepInputs = steps => steps.filter(step => step.approvers.length > 0).flatMap((step, index) => step.approvers.map(approver => ({
  actor: approver.actor,
  order: index
})));
export const existingStepsToInputs = approvalSteps => approvalSteps.map(step => ({
  actor: step.approver.actor,
  order: step.order
}));
export const countDistinctApprovers = steps => {
  const actorKeys = new Set();
  steps.forEach(step => step.approvers.forEach(approver => actorKeys.add(serializeActor(approver.actor))));
  return actorKeys.size;
};
export const hasEmptyStep = steps => steps.some(step => step.approvers.length === 0);
export const hasHumanApprover = steps => steps.some(step => step.approvers.some(approver => approver.actor.actorType === ACTOR.USER));
export const stepHasLockedApprover = (step, lockedActorKeys) => step.approvers.some(approver => lockedActorKeys.has(serializeActor(approver.actor)));
export const isStepGroupComplete = (step, approvedActorKeys, approvalRules) => {
  if (step.approvers.length === 0) {
    return false;
  }
  const isApproved = approver => approvedActorKeys.has(serializeActor(approver.actor));
  return approvalRules === ApprovalRules.ANY_CAN_APPROVE ? step.approvers.some(isApproved) : step.approvers.every(isApproved);
};
export const reorderChangesLockedStep = (steps, fromIndex, toIndex, lockedActorKeys) => {
  const reordered = [...steps];
  const [moved] = reordered.splice(fromIndex, 1);
  if (moved === undefined) {
    return false;
  }
  reordered.splice(toIndex, 0, moved);
  return steps.some((step, index) => {
    var _reordered$index;
    return stepHasLockedApprover(step, lockedActorKeys) && ((_reordered$index = reordered[index]) === null || _reordered$index === void 0 ? void 0 : _reordered$index.id) !== step.id;
  });
};
export const approvalStepsSignature = steps => steps.filter(step => step.approvers.length > 0).map(step => step.approvers.map(approver => serializeActor(approver.actor)).sort().join(',')).join('|');